export const EVENT_PRESENTATION_MARKDOWN_ELEMENTS: string[] = [
  'p',
  'ul',
  'ol',
  'li',
]
